<template>
  <div class="config-menu">
    <emat-block :name="$t('ChargingPillarMenu.charging_pillar_configuration')" style="max-width: 320px; margin: 0 auto;" :style="device === 'mobile' ? {minWidth: '100%'} : {maxWidth: '320px'}">
      <EmatBlockItem
        :label="$t('global.label.power')"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_power')"
        style="padding: 18px 15px 14px;"
      >
        <EmatTabs
            :tabs="powers"
            v-model="power"
        />
      </EmatBlockItem>
      <EmatBlockItem
        :label="$t('global.label.start/stop')"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_system')"
        style="padding: 15px 15px 14px;"
      >
        <EmatSelect
          :class="device"
          name="input-name"
          v-model="system"
          :options="systems"
        />
      </EmatBlockItem>

      <EmatBlockItem
        :label="$t('global.label.amount_of_connections')"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_double')"
        style="padding: 18px 15px 14px;"
      >
        <EmatTabs
            :tabs="connections"
            v-model="double"
        />
      </EmatBlockItem>

      <!--      todo send array to select -->
<!--      <emat-block-item :label="$t('global.label.ampere_setting')" :info="$store.getters['settings/info']('help_amp_settings')" style="padding: 16px 15px 13px;">-->
<!--        <emat-select-->
<!--            :class="device"-->
<!--            name="input-name"-->
<!--            v-model="setting"-->
<!--            :options="settings"></emat-select> &lt;!&ndash; todo systems = settings &ndash;&gt;-->
<!--      </emat-block-item>-->
    </emat-block>

    <products-block></products-block>
  </div>
</template>

<script>
import EmatBlock from 'Components/Layout/Block';
import EmatSelect from 'Components/Inputs/Select';
import EmatTabs from 'Components/Inputs/Tabs';
import EmatInfo from 'Components/General/Info';
import EmatBlockItem from 'Components/Layout/BlockItem';
import EmatCheckbox from 'Components/Inputs/Checkbox';
import EmatNumber from 'Components/Inputs/Number';
import EmatButton from 'Components/General/Button';
import EmatColorPicker from 'Components/General/ColorPicker';
import updateSettingMixin from "@/mixins/updateSettingMixin";
import ProductsBlock from "./ProductsBlock";

import {mapGetters} from "vuex";

export default {
  name: "ConfigurationMenu",

  mixins: [updateSettingMixin],

  components: {
    EmatBlock,
    EmatBlockItem,
    EmatTabs,
    EmatInfo,
    EmatSelect,
    EmatCheckbox,
    EmatNumber,
    EmatButton,
    EmatColorPicker,
    ProductsBlock,
  },

  data() {
    return {
      connections: [
        {value: false, label: this.$t('global.label.one_connection')},
        {value: true, label: this.$t('global.label.two_connections')}
      ],
      currentCategory: 0,
    }
  },

  methods: {
    updateBuild(prop, val) {
      this.$store.dispatch('build/change' + prop, {value: val})
    },
  },

  computed: {
    openProductModal: {
      get() {
        return this.$store.getters.getProductModal;
      },
      set(value) {
        this.$store.dispatch('setProductPopup', value)
      }
    },
    plug: {
      get() {
        return this.$store.state.build.plug
      },
      set(val) {
        this.updateBuild('Plug', val)
      },
    },
    power: {
      get() {
        return this.$store.state.build.power
      },
      set(val) {
        this.updateBuild('Power', val);
        this.updateSetting();
      },
    },
    system: {
      get() {
        return this.$store.state.build.system
      },
      set(val) {
        this.updateBuild('System', val)
      },
    },
    method: {
      get() {
        return this.$store.state.build.method
      },
      set(val) {
        this.updateBuild('Method', val)
      },
    },
    socket: {
      get() {
        return this.$store.state.build.socket
      },
      set(val) {
        this.updateBuild('Socket', val)
      },
    },
    setting: {
      get() {
        return this.$store.state.build.setting
      },
      set(val) {
        this.updateBuild('Setting', val)
      },
    },
    double: {
      get() {
        return this.$store.state.build.double
      },
      set(val) {
        this.updateBuild('Double', val)
      },
    },
    ...mapGetters({
      type: 'types/current',
      categories: 'categories/getAllCategories',
      productState: 'products/getAll',
      device: 'getDevice',
      getExperimentVariant: 'ABTesting/getExperimentVariant',
    }),
    systems() {
      return this.type.systems.sort((a, b) => {
        return a.sort - b.sort;
      }).map((c) => {
        return {
          id: c.id,
          label: c.name,
          extra: this.getExperimentVariant('p0ht7U2BRtK5oXDPk9U2zA') === 0 ?
            (c.default ? this.$t('global.label.standard') : ('+' + c.price.toFixed(2))):
            null,
          value: c.id
        }
      });
    },
    settings() {
      return this.type.powers.length > 0 ? this.type.powers[0].settings.map((c) => {
        return {id: c.id, label: c.name, value: c.id}
      }) : [];
    },
    powers() {
      return this.type.powers.map((c) => {
        return {id: c.id, label: c.name}
      });
    },
    categoryProducts() {
      if (this.currentCategory) {
        this.productState.forEach(stateProduct => {
          this.currentCategory.products.map( currentCategoryProduct => {
            if(stateProduct.id === currentCategoryProduct.id) {
              return currentCategoryProduct.amount = stateProduct.amount;
            }
            return currentCategoryProduct;
          })
        })
        return this.currentCategory.products;
      }
    }
  },
}
</script>

<style scoped lang="scss">
.config-menu {
  margin-top: 11px;

  .component-block-holder {
    .component-block {
      padding: 10px 15px;
      border-top: 1px solid #e7e7e7;
      background-color: #fafafa;
      text-align: left;

      .flex {
        display: flex;
        align-items: center;

        .sub-label {
          font-family: AntennaCond, sans-serif;
          font-size: 10px !important;
          color: rgba(0, 0, 0, .5);
          line-height: 1;
          width: 50%;
          margin-top: -5px;
        }
      }

      .info-popup {
        margin-top: 4px;
        position: relative;

        .info-icon {
          margin-right: 15px;
          cursor: pointer;
        }
      }

      .select-box {
        margin: 9.5px 0;
        position: relative;
        flex-grow: 1;
        background: #fff;
        border: 1px solid #d7dae2;
        user-select: none;
        box-shadow: 0 2px 3px rgba(0, 0, 0, .05);
        min-height: 32px;

        .value {
          padding-top: 8px;
          padding-bottom: 4px;
          display: flex;
          justify-content: space-between;
          position: relative;
          height: 32px;
          box-sizing: border-box;
          transition: background .3s ease;
          flex-shrink: 1;

          &.current-value {
            background: #fff;
            padding-left: 13px;
            padding-right: 28px;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;

            img {
              position: relative;
              left: 20px;
            }
          }
        }

        .name {
          font-size: 13px;
          line-height: 17px;
          transition: color .3s ease;
          color: #424140;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding-right: 5px;
        }

        .price {
          font-size: 10px;
          color: rgba(0, 0, 0, .3);
          font-weight: 700;
          display: block;
        }
      }
    }
  }
}
</style>
